var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87061 12.473C9.87061 10.7988 9.87061 9.96168 10.2127 9.53173C10.5102 9.15781 10.9613 8.94028 11.4381 8.9408C11.9864 8.94139 12.638 9.46433 13.941 10.5102L23.0835 17.8484C23.9194 18.5193 24.3374 18.8548 24.4887 19.2601C24.6214 19.6154 24.6214 20.007 24.4887 20.3623C24.3374 20.7676 23.9194 21.1031 23.0835 21.774L13.941 29.1122C12.638 30.1581 11.9864 30.681 11.4381 30.6816C10.9613 30.6821 10.5102 30.4646 10.2127 30.0907C9.87061 29.6607 9.87061 28.8236 9.87061 27.1494V12.473Z",
    stroke: "White",
    strokeOpacity: 0.8,
    strokeWidth: 2.07059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8589 12.4726C15.8589 10.7984 15.8589 9.96131 16.2009 9.53136C16.4984 9.15744 16.9495 8.93991 17.4264 8.94043C17.9747 8.94102 18.6262 9.46396 19.9293 10.5098L29.0718 17.848C29.9077 18.519 30.3257 18.8544 30.477 19.2597C30.6097 19.6151 30.6097 20.0066 30.477 20.3619C30.3257 20.7672 29.9077 21.1027 29.0718 21.7736L19.9293 29.1118C18.6262 30.1577 17.9747 30.6806 17.4264 30.6812C16.9495 30.6818 16.4984 30.4642 16.2009 30.0903C15.8589 29.6604 15.8589 28.8232 15.8589 27.149V12.4726Z",
    stroke: "White",
    strokeOpacity: 0.8,
    strokeWidth: 2.07059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 1.58827,
    y: 1.6935,
    width: 34.1647,
    height: 36.2353,
    rx: 5.17647,
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 2.07059
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next_icon.f61e9c29.svg";
export { ForwardRef as ReactComponent };